// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rd-0";